import t from 'react-translate';
import { MentorshipProgramRequest } from 'redux/schemas/models/mentorship-program-connections';
import MentoringRequest from './mentoring-request';
import { config } from '@config/pendo.config.json';

type MentoringRequestsListProps = {
  requests: MentorshipProgramRequest[];
};

const MentoringRequestsList = ({ requests }: MentoringRequestsListProps) => {
  const dataQATag =
    config.pendo.athena.mentorshipProgram.participantHome.requestsPanel
      .mentorRequestsList;
  const label = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.REQUESTS_PANEL.TITLE();

  return (
    <div className='p-4' data-qa={dataQATag}>
      <div className='heading-5 title mb-4'>{label}</div>
      <ul className='list-unstyled mb-0'>
        {requests.map((request, index) => (
          <li key={request.id}>
            <MentoringRequest index={index} {...request} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MentoringRequestsList;
